import * as React from 'react';

import { IState } from 'redux/global-reducers';
import { RouteComponentProps, withRouter } from 'react-router';
import { WithNamespaces, withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { handleError } from 'utils/common';
import { withErrorBoundary } from 'react-error-boundary';
import Fallback from '../Fallback';
import * as style from './styles.scss';
import Marquee from 'react-fast-marquee';

export interface IWordsBannerProps
  extends React.ClassAttributes<WordsBanner>,
    WithNamespaces,
    RouteComponentProps {
  readonly wordBannerQuery: IState['wordBannerQuery'];
}

class WordsBanner extends React.Component<IWordsBannerProps> {
  constructor(props: IWordsBannerProps) {
    super(props);
  }

  render() {
    return (
      <>
        <Marquee pauseOnHover={true} speed={45}>
          {this.props.wordBannerQuery
            .find((ele) => ele.word_banners)
            ?.word_banners.map((item: any, idx: number) => {
              return (
                <a
                  key={idx}
                  href={item.url}
                  className={style.StbItem}
                  target="_blank"
                  rel="noreferrer"
                >
                  <span style={{ fontSize: item.fontSize, color: item.color }}>
                    {item.title}
                  </span>
                </a>
              );
            })}
        </Marquee>
      </>
    );
  }
}

const mapStateToProps = (state: IState) => ({
  wordBannerQuery: state.wordBannerQuery,
});

export default withRouter(
  withErrorBoundary(
    withNamespaces('common')(connect(mapStateToProps)(WordsBanner)),
    Fallback,
    handleError
  )
);



// WEBPACK FOOTER //
// ./src/components/common/WordsBanner/index.tsx